/**
 * External Dependencies
 */
import 'jquery';

$(() => {
  // External links in new tab
  let domain = window.location.hostname;
  $('.prose:not(ul) a').each((_, elm) => {
    const self = $(elm);
    const href = self.attr('href');
    const target = self.attr('target');

    if (href.indexOf(domain) === -1 && href.indexOf('mailto:') === -1 && target !== '_self') {
      const text = self.text();
      self.html(`<span class="underline">${text}</span>`);
      self.addClass('inline-flex items-center no-underline');
      self.prepend('<span class="material-icons-outlined text-warmGray-400 relative top-px mr-2">link</span>');
    }
  });
});
